var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlog = function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#blog_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M35 15.417H25m10-8.75H5m30 17.916H25m10 8.75H5m2.667-6.666h8c.933 0 1.4 0 1.756-.182a1.67 1.67 0 0 0 .729-.728c.181-.357.181-.824.181-1.757v-8c0-.933 0-1.4-.181-1.757a1.67 1.67 0 0 0-.729-.728c-.356-.182-.823-.182-1.756-.182h-8c-.934 0-1.4 0-1.757.182-.314.16-.569.415-.728.728C5 14.6 5 15.067 5 16v8c0 .933 0 1.4.182 1.757.16.313.414.568.728.728.357.182.823.182 1.757.182"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blog_svg__a",
    x1: 32.338,
    x2: -25.648,
    y1: 7.403,
    y2: 32.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgBlog;